"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stripWhitespace;
var _isString = _interopRequireDefault(require("lodash/isString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function stripWhitespace() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(string)) {
    return string;
  }
  return string.replace(/\s/g, '');
}